/* import __COLOCATED_TEMPLATE__ from './photo-id-section.hbs'; */
import Component from '@glimmer/component';
import styles from './photo-id-section.module.scss';

export default class SiteDocumentsContactInfoPhotoIdSection extends Component {
  styles = styles;
}
